const production = true;
const URL_API = production?`https://api.institutoideias-sh.com.br/api/v1/`:`http://localhost:8000/api/v1/`;
const URL_AUTH = production?`https://api.institutoideias-sh.com.br/api/v1/login`:`http://localhost:8000/api/v1/login`;
const URL_BASE = production?`https://api.institutoideias-sh.com.br/api/v1/`:`http://localhost:8000/api/v1/`;
const URL_IMAGE = production?`https://api.institutoideias-sh.com.br/`:`http://localhost:8000/`;

export {URL_API, URL_AUTH, URL_BASE, URL_IMAGE}